import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chapters"
export default class extends Controller {
  connect() {
  }

  /*
   * Soft-deletes a chapter via an AJAX DELETE request after a confirmation prompt.
   * On success, removes the chapter's table row from the DOM so the list updates without
   * a full page reload.
   *
   * We use item.href (from the anchor tag's href attribute) rather than a constructed URL
   * so the correct chapter ID and route are already embedded by the server-rendered link.
   * item.dataset.id holds the DOM element ID of the table row to remove (e.g., "chapter_42"),
   * set as a data attribute in the view. The CSRF token is required for non-GET requests
   * even though this is AJAX — Rails' protect_from_forgery still applies.
   */
  deleteChapter(event) {
    event.preventDefault()
    var item = event.currentTarget

    var ans = confirm("Are you sure you want to delete this chapter?")
    if(ans) {
      $.ajax({
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        url: item.href,
        type: "DELETE",
        success: function(e) {
          if(e.status == 200){
            document.getElementById(item.dataset.id).remove()
          } else {
            alert("Chapter could not be deleted")
          }
        }
      });
    }
  }
}
